module.exports = __webpack_public_path__ + "1735e67d.svg";